import { render, staticRenderFns } from "./ListaVazia.vue?vue&type=template&id=26b19612&scoped=true"
import script from "./ListaVazia.vue?vue&type=script&lang=js"
export * from "./ListaVazia.vue?vue&type=script&lang=js"
import style0 from "./ListaVazia.vue?vue&type=style&index=0&id=26b19612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b19612",
  null
  
)

export default component.exports